module.exports = __webpack_public_path__ + "img/xiaodu.f0c8997d.jpg";